import { render, staticRenderFns } from "./reporteSalubridad.vue?vue&type=template&id=09e27a84&scoped=true"
import script from "./reporteSalubridad.vue?vue&type=script&lang=js"
export * from "./reporteSalubridad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e27a84",
  null
  
)

export default component.exports